export default {
  $CODE: '200',
  $AES_KEY: 'D513XDLZ027E4UMZ',
  $LIVE_AES_KEY: '06CVW8Y85LHIW2MB',
  $SIGN_KEY: 'DHCJ7MNCBIWTNZO5YIZ7HOGE6Y39A1P0',
  $LOGIN_KEY: 'SH1K692EMUADFS96',
  $CLIENT_ID: '2102321',
  $USER_SOURCE: 'TRANSPORT-TRANSPORT89820',
  $BASE_URL: '/api'
};
